import loginHulLogo from "../../assets/images/loginPage/loginHulLogo.svg";
import loginSamarth from "../../assets/images/samarth-logo.png";
import headerHulLogo from "../../assets/images/header/header.svg";
import samarthrHulLogo from "../../assets/images/samarth-logo.png";

const title = window.location.hostname !== "localhost" ? process.env.REACT_APP_ENV === 'production' ? "Samarth" : "Samarth-" + process.env.REACT_APP_ENV : 'Samarth-local env';

const constants = {
  applicationTitle: "Supply Chain Nerve Centre",
  loginSamarthogo: {
    name: "Samarth",
    path: loginSamarth,
  },
  routeToLandingPage: "/home/landing",
  welcomeMessage: "Welcome!",
  loginButtonText: "LOGIN",
  loginHulLogo: {
    name: "HUL Logo",
    path: loginHulLogo,
  },
  headerTitle: "SAMARTH (SC Nerve Center)",
  headerDate: "Last refreshed - 11 Feb 2025 5:30 PM",
  headerUserProfileGreetingMessage: "Hello ",
  headerHulLogo: {
    name: "HUL",
    path: headerHulLogo,
  },
  samarthHulLogo: {
    name: "Samarth",
    path: samarthrHulLogo,
  },
  addToActionCartTitle: "Action Cart",
  resetFilterTitle: "Reset Filter",
  executeActionsButtonDisplayText: "Execute Action",
  actionCartTitleText: "Action Cart",
  okButtonDisplayText: "Ok",
  previousRoute: -1,
  routeToAlertDetailsPage: "/samarth/alert_details",
};

export default constants;
